import { Component } from "react";

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


class MyDialogDeleteCourse extends Component{
    state = {open:false,myform:{}};
    setOpen = (value)=>{
        this.setState({open:value});
    }
     title = this.props.title; 
         body = this.props.body;
         actualcoursename = this.props.coursename;
         actionFunction = this.props.actionFunction; 
         actionTitle = this.props.actionTitle; 
         buttonTitle = this.props.buttonTitle;
    
         handleinput= (e)=>{
          const myform = {...this.state.myform};
          myform[e.target.name] = e.target.value;
          this.setState({myform},()=>{console.log(this.state.myform)});
          
        }
    render(){
        
        return <> 
        <Button variant="outlined" onClick={() =>this.setOpen(true)}>
        {this.buttonTitle}
      </Button>
        <Dialog
        open={this.state.open}
        onClose={()=>this.setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {this.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
               <p style={{color:"green"}}> {this.body} </p>
               
                <p><b>Enter course title to proceed:</b></p>
                <input type="text" name="coursename" onChange={this.handleinput} value={this.state.coursename}/>
                {/* <label for="title" className="form-label fw-bold" >Title</label>
                  <input type="text" className="form-control mb-3" onChange={this.handleinput} name='titlea' id="title"/>
                   */}

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>this.setOpen(false)}>Cancel</Button>
          {(this.state.myform.coursename == this.actualcoursename) && <Button style={{color:"red"}}  onClick={()=>{this.actionFunction()
          this.setOpen(false);
          }} autoFocus>
            {this.actionTitle}
          </Button>}
        </DialogActions>
      </Dialog> 
      </>;
    }
}

export default MyDialogDeleteCourse;